import { useEffect, useState } from "react";
import "../styles/rules.scss";
import { getRules } from "../components/api";
import { RuleItem } from "../components/RuleItem";
import { setNotificationMessage, setShowNotification } from "../store";
import { useNavigate } from "react-router-dom";

export const Rules = () => {

    const [rules, setRules] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getRules()
            .then((data) => { setRules(data) })
            .catch(error => {
                setNotificationMessage("Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }, []);

    const ruleClick = (rule) => {
        if (rule.isLink) {
            window.open(rule.text, '_blank');
        }
        else {
            navigate('/rule', { state: { ruleId: rule.id } });
        }
    }

    return (
        <div className="rules">
            <h2>Правила</h2>
            {rules.map(rule => (
                <RuleItem key={rule.id} data={rule} onClick={() => ruleClick(rule)} />
            ))}
        </div>
    )
}